function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.1 12c0-2.145.685-4.188 1.933-5.878A9.885 9.885 0 0112 2.1a9.901 9.901 0 019.076 5.94A9.869 9.869 0 0121.9 12c0 5.468-4.432 9.9-9.9 9.9-.372 0-.74-.02-1.107-.061C5.908 21.284 2.1 17.055 2.1 12zm9.9 2.7a2.697 2.697 0 002.7-2.7 2.7 2.7 0 10-2.7 2.7zM4.734 8.416a8.103 8.103 0 005.785 11.55l2.017-3.498a4.481 4.481 0 01-4.513-2.364l-3.29-5.688zm7.795 11.667A8.1 8.1 0 0019.639 9.3H15.6c.565.752.9 1.687.9 2.7a4.44 4.44 0 01-.686 2.387l-3.285 5.696zM12 7.5h6.737A8.098 8.098 0 0012 3.9a8.08 8.08 0 00-6.158 2.837l2.02 3.493A4.501 4.501 0 0112 7.5z"
});

var SvgBrowserChrome = function SvgBrowserChrome(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/browser-chrome.f9bf41cb.svg";
export { SvgBrowserChrome as ReactComponent };